<!--
  name : 이예닮
  desc : 사내계약 조회
  date : 2021-07-19
-->
<template>
  <v-container id="set_officeC" class="con_mpw">
    <v-row no-gutters class="row_mt-20 row_mb-40">
      <v-col cols="12" class="row_mb-20">
        <div class="txtst_info_gray">- 사내계약 요청 결과를 확인하는 페이지입니다. 해당 계약의 완료 여부는 문서함에서 확인하시기 바랍니다.</div>
      </v-col>
      <v-col cols="12" class="ta_right row_mb-20">
        <div class="dateBox" @click="reLoadContractList()">
          <span class="st_txt">{{reloadTime}}</span>
          <v-btn class="btn17_C01">갱신</v-btn>
        </div>
      </v-col>

      <!--list-->
      <v-col cols="12">
        <v-row no-gutters class="officeC_list">
            <v-col cols="12">
              <!--list-->
              <v-card class="officeC_carD st_faq" @click="handleRowClick(contractList)" v-for="(contractList, i) in contractList" :key="i">
                <v-list-item class="carD_box_clB">
                  <div class="carD_01">
                    <div class="carD_01_txt">
                      <span class="st_tt_01">{{ contractList.GrpNum }}</span>
                      <!--계약명-->
                      <span class="st_tt_01 mr-10px">{{contractList.ContractTitle}}</span>
                      <v-chip class="sucfal_chip">
                        <span class="pr-1">성공</span><span class="fc_C06">{{contractList.CompleteCount}} 건</span>
                        <span class="pl-1 pr-1">/</span>
                        <span class="pr-1">실패</span><span class="fc_C05">{{contractList.FailCount}} 건</span>
                      </v-chip>
                    </div>
                    <div class="dateBox">
                      <span class="st_txt">{{contractList.CreateDate | formatDate}}</span>
                    </div>
                    <div class="resultBox">
                      <!--요청결과 ***상태별 텍스트 변경*** st01:진행중 / st03:완료 / st05:실패 **/-->
                      <span class="noti_chip st01" v-if="contractList.IsSuccess === '진행중'">{{contractList.IsSuccess}}</span>
                      <span class="noti_chip st03" v-if="contractList.IsSuccess === '완료'">{{contractList.IsSuccess}}</span>
                      <span class="noti_chip st05" v-if="contractList.IsSuccess === '실패'">{{contractList.IsSuccess}}</span>
                    </div>
                  </div>
                </v-list-item>
              </v-card>

            </v-col>

          <!--계약 없을 때-->
          <v-col cols="12" v-if="contractList.length === 0">
            <div class="list_no_txt">
              검색된 계약 건이 없습니다.
            </div>
          </v-col>
        </v-row>

        <!--pageing-->
        <v-row no-gutters class="justify-center" v-if="totalCnt > 0">
          <v-pagination
            v-model="page"
            :length="pageing"
            @input="handleCurrentChange"
            circle
          ></v-pagination>
        </v-row>
      </v-col>
    </v-row>

    <!--popup-->
    <v-dialog v-model="officecView" max-width="1200px" persistent @keydown.esc="officecView = false">
      <v-card id="popStyle03">
        <v-card-title class="title">
          사내계약 요청 결과
          <v-btn fab class="popBtnClose" @click="officecView = false"></v-btn>
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12">
              <ul class="pattern_ulTxtBox li_mg02 float_rignt">
                <li>
                  <span class="txt_icon">성공</span>
                  <span class="txt_txt01 no_pr">{{completeCnt}} 건</span>
                </li>
                <li>
                  <span class="txt_icon">실패</span>
                  <span class="txt_txt01 no_pr">{{failCnt}} 건</span>
                </li>
                <li>
                  <span class="txt_icon">진행</span>
                  <span class="txt_txt01 no_pr">{{intCnt}} 건</span>
                </li>
              </ul>
            </v-col>

            <v-col class="officeC_list for_pop" cols="12" sm="12" md="12" lg="12" >
              <!-- list -->
              <v-card v-for="(contractDetail, i) in contractDetail" :key="i" class="officeC_carD st_faq">
                  <v-list-item class="carD_box_clB">
                    <div class="carD_01">
                      <div class="carD_01_txt">
                        <span class="st_num">{{ i + 1 }}</span>
                        <!--계약명-->
                        <span class="st_tt_01 mr-5">{{contractDetail.contractFileOriginalName}}</span>
                        <div class="carD_02_txt">
                          <ul class="pattern_ulTxtBox">
                            <li>
                              <span class="txt_tt">작성자</span>
                              <span class="txt_txt01 no_pr">{{detailWriter}}</span>
                            </li>
                            <li>
                              <span class="txt_tt">수신자</span>
                              <span class="txt_txt02 no_pr">{{contractDetail.receiverName}}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <!--요청결과 ***상태별 텍스트 변경*** st01:진행중 / st03:완료 / st05:실패 **/-->
                      <div class="resultBox">
                        <span class="noti_chip st01" v-if="contractDetail.docStatus.code === null || contractDetail.docStatus.code === 'GR0010' || contractDetail.docStatus.code === 'GR0020' || contractDetail.docStatus.code === 'GR0030' || contractDetail.docStatus.code === 'GR0040'" >진행중</span>
                        <span class="noti_chip st05" v-if="contractDetail.docStatus.code === 'GR0060' || contractDetail.docStatus.code === 'GR0050'" >실패</span>
                        <span class="noti_chip st03" v-if="contractDetail.docStatus.code === 'GR0070'">완료</span>
                      </div>
                      <!--계약 처리일-->
                      <div class="dateBox">
                        <span class="st_txt">{{contractDetail.creationDatetime}}</span>
                      </div>
                    </div>
                  </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>


        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="officecView = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  </v-container>
</template>


<script>
import { getOfficeContractList, getOfficeContractDetail } from '@/api/setting/officeContract'
import moment from 'moment'

export default {
  name: 'officeContractList_page',
  data () {
    return {
      officecView: false, //
      completeCnt: 0,
      failCnt: 0,
      intCnt: 0,
      totalCnt: 0,
      pageing: 0,
      detailWriter: '',
      reloadTime: '',
      contractDetailVisible: false,
      contractList: [],
      pageParam: {
        page: 0,
        size: 10
      },
      page: 0,
      contractDetail: [],
      // 기업관리자인지 아닌지 여부
      isAdmin: true
    }
  },
  created () {
  },
  mounted () {
    this.track()
    this.search()
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm')
      }
    }
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: 'officeContractList'
      })
    },

    // 사내계약 전송 현황 List
    search () {
      getOfficeContractList({ pageParams: this.pageParam }).then(response => {
        this.contractList = response.rdata.contractList
        this.totalCnt = response.rdata.totalCnt
        this.getCurrentTime()
        if(response.rdata.totalCnt) {
          this.pageing = Math.ceil(this.totalCnt/10)
        }
      })
    },

    // 사내계약 전송 현황 Detail
    handleRowClick (row) {
      getOfficeContractDetail({ contractDetailIdx: row.GroupID }).then(response => {
        this.completeCnt = row.CompleteCount
        this.failCnt = row.FailCount
        this.detailWriter = row.UsrName
        this.intCnt = row.TotalCount - this.failCnt - this.completeCnt
        this.contractDetail = response.rdata.detailList
        this.contractDetailVisible = true
        this.officecView = true
      })
    },

    // 갱신
    reLoadContractList () {
      this.contractList = []
      this.totalCnt = 0
      this.pageing = 0

      this.$refs.loading.start('사내계약 리스트를 받아오는 중 입니다.')
      getOfficeContractList({ pageParams: this.pageParam }).then(response => {
        this.$refs.loading.end()
        this.contractList = response.rdata.contractList
        this.totalCnt = response.rdata.totalCnt
        this.getCurrentTime()
        if(response.rdata.totalCnt) {
          this.pageing = Math.ceil(this.totalCnt/10)
        }
      })
    },

    // Pageing
    handleCurrentChange (val) {
      this.pageParam.page = 1
      this.pageParam.page = (val - 1)
      this.search()
    },

    getCurrentTime () {
      const today = new Date()
      this.reloadTime = today.toLocaleTimeString();
    }
  }
}
</script>
<style>
.list_no_txt {
  padding: 20px 0;
  width: 100%;
  font-size: .8rem;
  color: #a4a5a9;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}

.sucfal_chip {
  margin: 0 !important;
  padding: 2px 8px;
  font-size: .5rem;
  color: #a4a5a9 !important;
  background: #fff !important;
  vertical-align: middle;
  border: 1px solid #bfc0bf;
}
</style>
